<template>
  <div>
    <div class="title">推广路径</div>
    <div class="titleLine mb-20">
      <p class="titleLine_title">推广路径用途 </p>
      <p class="titleLine_desc">可导出各页面小程序码常用于企业广告及宣传推广，链接可用于公众号内推广。 用户通过推广路径访问小程序时，如有浏览过名片则进入上一次浏览的名片，如没有则随机进入默认名片  </p>
    </div>
    <div class="content">
      <el-table
              :data="tableData"
              border
              style="width: 100%"
              align="center"
              @selection-change="handleSelectionChange">
        <el-table-column
                header-align="center"
                align="center"
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="cate"
                label="商品分类"
                width="300">
          <template slot-scope="scope">
            <div>
              <span v-for="(item,indx) in scope.row.cat_id" :key="indx">{{item}} </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                prop="goods_name"
                header-align="center"
                align="center"
                label="商品名称"
                width="200">
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="shop_price"
                label="单价">
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                label="操作">
          <template slot-scope="scope">
            <div class="btn_line_span">
              <span v-clipboard:copy="`pages/mall/detail/detail?scene=0_122_${scope.row.id}_${scope.row.id}`" v-clipboard:success="onCopyUrl" v-clipboard:error="onErrorUrl">复制</span>
              <span @click="exportCode(scope.row.id,scope.row.goods_name)">导出小程序码</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px" class="pageBody">
        <div class="pageBody_left">
          <el-button size="small" disabled>批量导出小程序码</el-button>
        </div>
        <div class="pageBody_right">
          <!-- <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="1">
          </el-pagination> -->
          <el-pagination
            background
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
            @current-change="pageIndexChange"
          ></el-pagination>
        </div>
      </div>
      <QRcodeDialog :visible.sync="qrcodedialog" v-if="qrcodedialog" :qrcodeId="qrcodeId" :username="qrcodename" :qrcodeType="qrcodeType" :qrcodeStatus="qrcodeStatus"></QRcodeDialog>
    </div>
  </div>
</template>
<script>
  import QRcodeDialog from "@/components/dialog/QRcodeDialog.vue";
  import { pagination } from "@/util/util.js";
  import api from "@/api.js"

  export default {
    components: {
      QRcodeDialog
    },
    data() {
      return {
        qrcodedialog: false,
        qrcodeId: false,
        qrcodeType: 2, // 1 角色员工二维码 2 推广二维码
        qrcodeStatus: 1,//(0小程序页、1商品)
        qrcodename: '',
        tableData: [],
        multipleSelection: '',
        version: 0,
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        listData: {
          name: "",
          cat_id: "",
          page: 0
        }
      }
    },
    created(){
      this.initFn()
    },
    methods: {
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.InitFn();        
      },
      initFn(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.listData.page = this.page.pageindex;
        this.axios
            .post(api.companyadmin_path_goods, this.listData)
            .then(response => {
              if (response.data.code == 0) {
                // this.$message({
                //   message: '设置成功！',
                //   type: 'success'
                // });
                this.tableData = response.data.list;
                this.version = response.data.version;
                this.page.total = response.data.all_page;
                loading.close();
              } 
            })
            .catch(response => {
            });
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      exportCode(id,name){
        if(this.version){
          this.qrcodeId = id
          this.qrcodename = name
          this.qrcodedialog = true
        }else{
          this.$confirm('还未发布版本请先上传小程序版本?', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
        }
      },
      onCopyUrl(e){
        this.$message.success("复制成功！");
      },
      onErrorUrl(e){
        this.$message.error("复制失败！");
      }
    }
  }
</script>
